// Cetak resit ke printer Bluetooth melalui app RawBT (Android) atau dialog cetak pelayar.
import { mainBle, kitchenBle } from "@/pos/lib/ble";
const KEY = "alfaz_pos_printer";
const DEFAULTS = { method: "rawbt", width: 32, autoOnline: false, autoPaid: true, kitchenTicket: true };

export const getPrinter = () => ({ ...DEFAULTS, ...JSON.parse(localStorage.getItem(KEY) || "{}") });
export const setPrinter = (cfg) => { localStorage.setItem(KEY, JSON.stringify(cfg)); window.dispatchEvent(new Event("printer-changed")); };

// Mod tiket dapur (dari pelayan): off | same (1 tablet 2 printer) | tablet (tablet dapur berasingan)
export const getKitchenMode = () => localStorage.getItem("alfaz_kitchen_mode") || "same";
export const setKitchenMode = (m) => { localStorage.setItem("alfaz_kitchen_mode", m); window.dispatchEvent(new Event("printer-changed")); };
// Peranan tablet ini dalam mod "tablet": kaunter | dapur
export const getRole = () => localStorage.getItem("alfaz_tablet_role") || "kaunter";
export const setRole = (r) => { localStorage.setItem("alfaz_tablet_role", r); window.dispatchEvent(new Event("printer-changed")); };

const ascii = (s) => String(s ?? "").normalize("NFD").replace(/[\u0300-\u036f]/g, "").replace(/[^\x20-\x7E]/g, "?");
const money = (n) => Number(n || 0).toFixed(2);
const when = (iso) => new Date(iso || Date.now()).toLocaleString("ms-MY", { timeZone: "Asia/Kuala_Lumpur", day: "2-digit", month: "short", year: "numeric", hour: "2-digit", minute: "2-digit" });
const TYPE = { dine_in: "MAKAN SINI", takeaway: "BUNGKUS / AMBIL", delivery: "DELIVERY" };
const METHOD = { tunai: "Tunai", qr: "QR DuitNow", online: "Bayaran Online" };

function wrap(text, w) {
  const out = [];
  ascii(text).split("\n").forEach((para) => {
    let cur = "";
    para.split(" ").forEach((word) => {
      while (word.length > w) { if (cur) { out.push(cur); cur = ""; } out.push(word.slice(0, w)); word = word.slice(w); }
      if ((cur ? cur.length + 1 : 0) + word.length > w) { out.push(cur); cur = word; } else cur = cur ? `${cur} ${word}` : word;
    });
    out.push(cur);
  });
  return out;
}

class Doc {
  constructor(w) { this.w = w; this.ops = []; }
  text(t, o = {}) { const w = o.big ? Math.floor(this.w / 2) : this.w; wrap(t, w).forEach((l) => this.ops.push({ l, ...o })); return this; }
  lr(l, r, o = {}) {
    const w = o.big ? Math.floor(this.w / 2) : this.w;
    r = ascii(r); const lines = wrap(l, Math.max(w - r.length - 1, 8));
    lines.forEach((x, i) => this.ops.push({ l: i === lines.length - 1 ? x.padEnd(w - r.length) + r : x, ...o }));
    return this;
  }
  hr() { this.ops.push({ l: "-".repeat(this.w) }); return this; }
}

function header(d, shop) {
  d.ops.push({ logo: true, center: true, l: "" });
  d.text(shop?.shop_name || "POKYA RESTAURANT", { center: true, bold: true, big: true });
  if (shop?.ssm) d.text(`(${shop.ssm})`, { center: true });
  if (shop?.address) d.text(shop.address, { center: true });
  if (shop?.phone) d.text(`Tel: ${shop.phone}`, { center: true });
  return d.hr();
}

function items(d, list, withPrice) {
  list.forEach((it) => {
    if (withPrice) { d.text(it.name); d.lr(`  ${it.qty} x ${money(it.price)}`, money(it.subtotal)); }
    else d.text(`${it.qty} x ${it.name}`, { bold: true, big: true });
    if (it.note) d.text(`  >> ${it.note}`, { bold: true });
  });
}

export function saleDoc(s, shop, w) {
  const d = header(new Doc(w), shop);
  d.text(`No: ${s.number}`).text(`Tarikh: ${when(s.created_at)}`).text(`Juruwang: ${s.cashier}`);
  if (s.customer_name) d.text(`Pelanggan: ${s.customer_name}`);
  if (s.status === "batal") d.text("*** DIBATALKAN ***", { center: true, bold: true });
  d.hr(); items(d, s.items, true); d.hr();
  d.lr("Subjumlah", money(s.subtotal));
  if (s.discount > 0) d.lr("Diskaun", `-${money(s.discount)}`);
  if (s.rounding) d.lr("Pembundaran", money(s.rounding));
  d.lr("JUMLAH", `RM${money(s.total)}`, { bold: true, big: true });
  d.lr(METHOD[s.payment_method] || s.payment_method, money(s.amount_received));
  if (s.payment_method === "tunai") d.lr("Baki", money(s.change));
  d.hr(); if (shop?.footer) d.text(shop.footer, { center: true });
  return d;
}

export function kitchenDoc(o, w) {
  const d = new Doc(w);
  d.text("TIKET DAPUR", { center: true, bold: true });
  d.text(`#${o.number}${o.order_no ? ` (${o.order_no})` : ""}`, { center: true, bold: true, big: true });
  d.text(`${TYPE[o.type] || o.type}${o.table_number ? ` - MEJA ${o.table_number}` : ""}`, { center: true, bold: true });
  d.text(when(o.created_at), { center: true });
  if (o.customer_name) d.text(`Pelanggan: ${o.customer_name}`);
  d.hr(); items(d, o.items, false); d.hr();
  if (o.note) d.text(`NOTA: ${o.note}`, { bold: true });
  return d;
}

export function onlineDoc(o, shop, w) {
  const d = header(new Doc(w), shop);
  d.text(`PESANAN APP ${o.order_no || ""}`, { center: true, bold: true, big: true });
  d.text(`Order #${o.number} - ${TYPE[o.type]}`, { center: true }).text(when(o.created_at), { center: true }).hr();
  d.text(`Nama: ${o.customer_name}`).text(`Tel: ${o.customer_phone}`);
  d.hr(); items(d, o.items, true); d.hr();
  d.lr("JUMLAH", `RM${money(o.total)}`, { bold: true, big: true });
  d.text(o.online_paid ? "SUDAH DIBAYAR ONLINE" : "BAYAR DI KAUNTER", { center: true, bold: true });
  if (o.note) { d.hr(); d.text(o.note.split(" · ").slice(1).join("\n")); }
  d.hr(); if (shop?.footer) d.text(shop.footer, { center: true });
  return d;
}

export function testDoc(w) {
  const d = new Doc(w);
  d.text("UJIAN PRINTER", { center: true, bold: true, big: true }).text("POKYA RESTAURANT POS", { center: true }).hr();
  d.lr("Lebar kertas", `${w} aksara`).text(when()).hr().text("Printer berjaya disambung!", { center: true });
  return d;
}

let LOGO = null;
async function loadLogo() {
  if (LOGO) return LOGO;
  try {
    const img = new Image();
    img.src = "/img/logo-bw.png";
    await img.decode();
    const w = img.width, h = img.height, c = document.createElement("canvas");
    c.width = w; c.height = h;
    const ctx = c.getContext("2d");
    ctx.drawImage(img, 0, 0);
    const px = ctx.getImageData(0, 0, w, h).data, bw = Math.ceil(w / 8), data = new Uint8Array(bw * h);
    for (let y = 0; y < h; y++) for (let x = 0; x < w; x++) {
      const i = (y * w + x) * 4;
      if (px[i + 3] > 128 && px[i] < 128) data[y * bw + (x >> 3)] |= 0x80 >> (x & 7);
    }
    LOGO = { bw, h, data };
  } catch (e) { LOGO = null; }
  return LOGO;
}

function toEscPos(docs) {
  const b = [];
  const push = (...x) => b.push(...x);
  docs.forEach((d) => {
    push(0x1b, 0x40);
    d.ops.forEach((o) => {
      if (o.logo) {
        if (LOGO) { push(0x1b, 0x61, 1, 0x1d, 0x76, 0x30, 0, LOGO.bw & 0xff, LOGO.bw >> 8, LOGO.h & 0xff, LOGO.h >> 8); LOGO.data.forEach((x) => b.push(x)); push(0x0a); }
        return;
      }
      push(0x1b, 0x61, o.center ? 1 : 0, 0x1b, 0x45, o.bold ? 1 : 0, 0x1d, 0x21, o.big ? 0x11 : 0);
      for (const ch of o.l) push(ch.charCodeAt(0));
      push(0x0a);
    });
    push(0x1b, 0x64, 4, 0x1d, 0x56, 0x42, 0x00);
  });
  return new Uint8Array(b);
}

function toHtml(docs, w) {
  const esc = (s) => s.replace(/[&<>]/g, (c) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;" }[c]));
  const body = docs.map((d) => d.ops.map((o) => (o.logo ? `<div style="text-align:center"><img src="${window.location.origin}/img/logo.png" style="width:120px;height:120px"></div>` : `<div style="text-align:${o.center ? "center" : "left"};font-weight:${o.bold ? 700 : 400};font-size:${o.big ? 18 : 12}px">${esc(o.l) || "&nbsp;"}</div>`)).join("")).join('<div style="page-break-after:always"></div>');
  return `<html><head><style>@page{size:${w > 40 ? 80 : 58}mm auto;margin:2mm}body{font-family:monospace;white-space:pre;margin:0}</style></head><body>${body}</body></html>`;
}

const b64 = (bytes) => { let s = ""; bytes.forEach((x) => { s += String.fromCharCode(x); }); return btoa(s); };

function viaSocket(bytes) {
  return new Promise((resolve) => {
    let done = false;
    const finish = (ok) => { if (!done) { done = true; resolve(ok); } };
    try {
      const ws = new WebSocket("ws://127.0.0.1:40213/");
      ws.binaryType = "arraybuffer";
      ws.onopen = () => { ws.send(bytes.buffer); setTimeout(() => ws.close(), 300); finish(true); };
      ws.onerror = () => finish(false);
      setTimeout(() => finish(false), 1500);
    } catch (e) { finish(false); }
  });
}

function viaBrowser(html) {
  const f = document.createElement("iframe");
  f.style.cssText = "position:fixed;right:0;bottom:0;width:0;height:0;border:0";
  document.body.appendChild(f);
  f.contentDocument.open(); f.contentDocument.write(html); f.contentDocument.close();
  setTimeout(() => { f.contentWindow.focus(); f.contentWindow.print(); setTimeout(() => f.remove(), 60000); }, 800);
}

export async function printDocs(docs, { socketOnly = false, kitchen = false } = {}) {
  const cfg = getPrinter();
  if (!docs.length) return "none";
  if (!kitchen && cfg.method !== "browser") await loadLogo();
  if (kitchen) return (await kitchenBle.write(toEscPos(docs))) ? "ble" : "failed";
  if (cfg.method === "browser") { viaBrowser(toHtml(docs, cfg.width)); return "browser"; }
  const bytes = toEscPos(docs);
  if (cfg.method === "direct") return (await mainBle.write(bytes)) ? "ble" : "failed";
  if (await viaSocket(bytes)) return "socket";
  if (socketOnly) return "failed";
  window.location.href = `intent:base64,${b64(bytes)}#Intent;scheme=rawbt;package=ru.a402d.rawbtprinter;end;`;
  return "intent";
}
